import React from 'react';

const BadgeApple = ({
  children,
  variant = 'default',
  size = 'md',
  icon: Icon,
  className = '',
}) => {
  const variantClasses = {
    default: 'apple-badge',
    blue: 'apple-badge apple-badge-blue',
    green: 'apple-badge apple-badge-green',
    red: 'apple-badge apple-badge-red',
    orange: 'apple-badge apple-badge-orange',
    purple: 'apple-badge apple-badge-purple',
  };

  const sizeClasses = {
    sm: 'text-[10px] px-2 py-0.5',
    md: '',
    lg: 'text-sm px-3 py-1',
  };

  const classes = [
    variantClasses[variant] || variantClasses.default,
    sizeClasses[size] || '',
    className,
  ].filter(Boolean).join(' ');

  const iconSize = {
    sm: 10,
    md: 12,
    lg: 14,
  }[size] || 12;

  return (
    <span className={classes}>
      {Icon && <Icon size={iconSize} />}
      {children}
    </span>
  );
};

export default BadgeApple;
